import { app } from "./firebase";
import {
  getFirestore,
  collection,
  doc,
  getDocs,
  getDoc,
  updateDoc,
  setDoc,
} from "firebase/firestore";
import { useSelector, useDispatch } from "react-redux";
import {
  setRuleDataSetUp,
  setAdminSetRuleLanguageData,
} from "./app/pages/AxiosRtk/SetRules";

function useFirebase() {
  const db = getFirestore(app);

  const dispatch = useDispatch();
  const { setRulesData } = useSelector(({ setRules }) => setRules);

  async function getCollectionData(
    deviceId = "",
    collectionName = "SetRuleDataModel"
  ) {
    try {
      const deviceRef = doc(db, deviceId.toString(), collectionName);
      const querySnapshot = await getDoc(deviceRef);

      if (collectionName === "SetRuleDataModel") {
        dispatch(setRuleDataSetUp(querySnapshot.data() ?? null));
      } else if (collectionName === "Languages") {
        dispatch(setAdminSetRuleLanguageData(querySnapshot.data() || []));
      }

      return querySnapshot.data();
    } catch (e) {
      console.error("Error getting document: ", e);
    }
  }

  async function getCollectionDataForCopySetting(
    deviceId = "",
    collectionName = "SetRuleDataModel"
  ) {
    try {
      const deviceRef = doc(db, deviceId.toString(), collectionName);
      const querySnapshot = await getDoc(deviceRef);

      return querySnapshot.data();
    } catch (e) {
      console.error("Error getting document: ", e);
    }
  }

  async function postCollectionData(
    deviceId,
    data,
    collectionName = "SetRuleDataModel"
  ) {
    try {
      const docVal = doc(db, deviceId.toString(), collectionName);
      await updateDoc(docVal, data);
      return true;
    } catch (e) {
      console.error("Error adding document: ", e);
      return e;
    }
  }

  async function postCollectionDataForCopySetting(
    deviceId,
    data,
    collectionName = "SetRuleDataModel"
  ) {
    try {
      getCollectionDataForCopySetting(deviceId)
        .then(async (res) => {
          if (res) {
            const docVal = doc(db, deviceId.toString(), collectionName);
            await updateDoc(docVal, data);
            return true;
          } else {
            const docVal = doc(db, deviceId.toString());
            await setDoc(docVal, data);
            return true;
          }
        })
        .catch((err) => console.log("error", err));
    } catch (e) {
      console.error("Error adding document: ", e);
      return e;
    }
  }

  async function createCollectionData(
    deviceId,
    data,
    collectionName = "SetRuleDataModel"
  ) {
    try {
      const docVal = doc(db, deviceId.toString(), collectionName);
      await setDoc(docVal, data);
      return true;
    } catch (e) {
      console.error("Error in creating new collection:", e);
      return e;
    }
  }

  async function getDeviceStatus(deviceId) {
    const result = await getDocs(
      collection(
        db,
        deviceId?.toString(),
        "UsedAppTimeDataModel",
        "deviceStatus"
      )
    );
    const res = [];
    result?.forEach((item) => {
      res.push({
        id: item?.id,
        data: item?.data(),
      });
    });
    return res[0];
  }

  async function getCurrentLocation(deviceId) {
    const result = await getDoc(
      doc(db, deviceId?.toString(), "CurrentLocation")
    );
    return result?.data();
  }

  async function getLastUsedAppDataModel(deviceId) {
    const result = await getDoc(
      doc(db, deviceId?.toString(), "LastUsedAppDataModel")
    );
    return result?.data();
  }

  function callFirebase(deviceId, payload) {
    if (setRulesData) {
      postCollectionData(deviceId, payload);
    } else {
      createCollectionData(deviceId, payload);
    }

    getCollectionData(deviceId);
  }

  async function getDefaultSettingData(collectionName = "DefaultSettings") {
    try {
      const deviceRef = doc(db, "AdminSetRuleData", collectionName);
      const querySnapshot = await getDoc(deviceRef);

      return querySnapshot.data();
    } catch (e) {
      console.error("Error getting document: ", e);
    }
  }

  return {
    getCollectionData,
    postCollectionData,
    createCollectionData,
    getDeviceStatus,
    getCurrentLocation,
    getLastUsedAppDataModel,
    getCollectionDataForCopySetting,
    postCollectionDataForCopySetting,
    callFirebase,
    getDefaultSettingData
  };
}

export default useFirebase;
